import React from 'react'
import { ActionIcon, type ActionIconProps } from '@mantine/core'

export type AppIconButtonProps = ActionIconProps;

export default function AppIconButton (props: AppIconButtonProps) {
  return <ActionIcon radius="md" {...props} />
}
